import { render, staticRenderFns } from "./newCategory.vue?vue&type=template&id=f22f3660"
import script from "./newCategory.vue?vue&type=script&lang=js"
export * from "./newCategory.vue?vue&type=script&lang=js"
import style0 from "./newCategory.vue?vue&type=style&index=0&id=f22f3660&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports